const scrollOptions: ScrollToOptions = {
    top: 0,
    left: 0,
    behavior: 'smooth' // *unsupported by Edge and IE*
};
export function scrollToTop(elementRef?: Element | null): void {
    if (elementRef) {
        elementRef.scrollTo(scrollOptions);
    } else {
        window.scrollTo(scrollOptions);
    }
}
